import React from 'react';
import "./c37t_html_popup.scss";
import {PageLeftItem} from "../../model/page";
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {insertHtml} from "../../utils/dom";

export interface C37THtmlPopupData extends PageLeftItem {
    title: string;
    content: string;
}

/**
 * The component renders a light blue button with an icon. When it is clicked it shows
 */
class C37THtmlPopup extends TemplateComponent<C37THtmlPopupData> {

    static readonly ID: string = "html_popup";

    state: {
        opened: boolean
    };

    constructor(props: TemplateComponentProps<C37THtmlPopupData>) {
        super(props);

        this.state = {
            opened: false
        }
    }


    flipPopup() {
        this.setState({
            opened: !this.state.opened
        })
    }

    componentRender(data: C37THtmlPopupData): React.ReactElement<any> {
        return (
            <div className={`c37t-html-popup ${this.state.opened ? "opened" : ""}`}>
                <div className="popup-button-container" onClick={() => this.flipPopup()}>
                    <div className="popup-button" />
                </div>
                <div className="html-popup">
                    <h3 className="popup-title">{data.title}</h3>
                    <div className="popup-content editor-html" {...insertHtml(data.content)} />
                </div>
            </div>
        );
    }
}

export default C37THtmlPopup;
